<template>
  <ion-card mode="ios" style="margin: 15px 0">
    <ion-card-header>
      <slide-y-up-transition :duration="700">
        <h6 v-show="show" class="text-up m-0">Twój profil</h6>
      </slide-y-up-transition>
      <slide-y-up-transition :duration="500" :delay="200">
        <h2 v-show="show" class="m-0" style="color: #000">{{ getProfile.first_name }} {{ getProfile.last_name }}</h2>
      </slide-y-up-transition>
    </ion-card-header>
    <ion-card-content>
      <div v-for="(item,index) in getProfile.places">
        <slide-y-up-transition :duration="600+(index*50)" :delay="300+(index*50)">
          <p v-if="show">
            <svg v-if="item.verified" class="icon icon-checkmark-black" style="width:15px">
              <use xlink:href="#icon-checkmark-black"></use>
            </svg>
            <span><strong>{{ item.role_name }}</strong> w {{ item.name }}</span>
            <span v-if="!item.verified" class="unverified-place">Niezweryfikowany</span>
          </p>
        </slide-y-up-transition>
      </div>
      <div v-if="getProfile.places.length === 0">
        <slide-y-up-transition :duration="300" :delay="200">
          <p v-if="show">Nie jesteś jeszcze w żadnym lokalu.</p>
        </slide-y-up-transition>
      </div>
      <slide-y-up-transition :duration="500" :delay="400">
        <div v-if="show">
          <ion-button mode="ios"
                      fill="outline"
                      size="small"
                      @click="goTo('UserJoinPlace')"
                      class="mt-10">Dołącz do lokalu
          </ion-button>
        </div>
      </slide-y-up-transition>
    </ion-card-content>
  </ion-card>
</template>

<script>
  import goTo from '@/mixins/goto';
  import { mapGetters } from 'vuex';

  export default {
    name: 'CardUserProfile',
    mixins: [goTo],
    computed: {
      ...mapGetters('profile', ['getProfile']),
    },
    data(){
      return{
        show: false
      }
    },
    mounted(){
      this.show = true;
      this.$store.dispatch('profile/PROFILE_REQUEST'); // requested: reload profile
    }
  }
</script>

<style lang="scss" scoped>
  ion-card-header{
    --background: #ffffff;
  }
  ion-card-content{
    padding: 0 20px 20px 20px;
  }
  .unverified-place{
    margin-left: 6px;
    padding: 4px 6px;
    font-size: 10px;
    letter-spacing: 1px;
    color: #fff;
    border-radius: 5px;
    background: #9d9d9d;
  }
</style>